import { asWidgetProps } from 'Src/types/widget-helpers';
import React from 'react';
import type { ComponentProps } from 'react';
import { ProductInformationSliderContainer } from 'Components/widgets/product-information-slider/ProductInformationSlider.container';
import type { TeaserCardProps } from './teaser-cards-card/TeaserCardsCard';
import { TeaserCardsCard } from './teaser-cards-card/TeaserCardsCard';
import { TeaserCardsLayer } from './teaser-cards-layer/TeaserCardsLayer';
export type CardProps = TeaserCardProps & {
  layerBlocks?: Array<any>;
  layerDescription?: string;
  layerTitle?: string;
  link: {
    onClick?: () => void;
    url?: string;
  };
};
export const resolveLayerData = (cardData: CardProps) => {
  const { image, layerTitle: title, layerDescription: description, layerBlocks: blocks } = cardData;
  return Promise.resolve({
    blocks,
    description,
    image,
    title,
  });
};
type Props = {
  backNavigationLabel: string;
  cards: Array<CardProps>;
  scrollBackwardLabel: string;
  scrollForwardLabel: string;
  sliderQueryName: string;
};
export const TeaserCards = ({
  backNavigationLabel,
  cards = [],
  scrollBackwardLabel,
  scrollForwardLabel,
  sliderQueryName,
}: Props) => {
  return (
    <ProductInformationSliderContainer
      {...asWidgetProps<ComponentProps<typeof ProductInformationSliderContainer>>({
        backNavigationLabel: backNavigationLabel,
        isExpanded: true,
        queryLayer: sliderQueryName,
        renderDetail: (layerData) => (
          <TeaserCardsLayer
            {...asWidgetProps<ComponentProps<typeof TeaserCardsLayer>>(layerData)}
          />
        ),
        scrollBackwardLabel: scrollBackwardLabel,
        scrollForwardLabel: scrollForwardLabel,
        sliderIndex: 1,
      })}
    >
      {cards.map((card, index) => (
        <TeaserCardsCard
          key={card.title || index}
          {...asWidgetProps<ComponentProps<typeof TeaserCardsCard>>({
            card: card,
            fetchDetail: () => resolveLayerData(card),
            link: card.link,
          })}
        />
      ))}
    </ProductInformationSliderContainer>
  );
};
